import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export const Route = createFileRoute("/unauthorized")({
  component: Unauthorized,
});

function Unauthorized() {
  const { user, logout, isInitialLoading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate({ to: "/login" });
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  // Show loading state while auth is being checked
  if (isInitialLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="p-8 text-center bg-card rounded-lg shadow-md max-w-md w-full">
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="p-8 text-center bg-card rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
        <p className="text-muted-foreground mb-2">
          Your account ({user?.email || "Unknown"}) is not authorized to access
          this admin panel.
        </p>
        <p className="text-sm text-muted-foreground mt-4 mb-6">
          Please contact an administrator if you believe this is an error.
        </p>
        {user && (
          <Button onClick={handleLogout} variant="outline" className="w-full">
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        )}
      </div>
    </div>
  );
}
